
import en from './en'
import ch from './zh-CN'
export default {
  en,
  ch
}